module.exports = __webpack_public_path__ + "img/award.dfdd02cb.svg";